// extracted by mini-css-extract-plugin
export default {"blender_bottle_item":"cK","blender_bottle_img":"eK","blender_bottle_info":"fK","blender_bottle_title":"gK","blender_bottle_bold":"hK","blender_bottle_usual":"iK","blender_bottle_item_mob":"jK","addbutton":"kK","blender_bottle_title_mob":"lK","blender_bottle_bold_mob":"mK","blender_bottle_usual_mob":"nK","bolder":"oK","bottom_margin_4":"pK","bottom_margin_16":"qK"};
    if(module.hot) {
      // 1726593106344
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  